import PrimarySection from "../components/UI/PrimarySection";
import homeBackgroundImg from "../assets/images/home-bg.png";
import styles from "./HomePage.module.css";
import headingImg from "../assets/images/homepage-heading.png";
import CtaLink from "../components/CtaLink/CtaLink";
import Details from "../components/Home/Details";
import Facilities from "../components/Home/Facilities";
import Events from "../components/Home/Events";
import Info from "../components/Home/Info";
import InfoSecondary from "../components/Home/InfoSecondary";
import InfoTertiary from "../components/Home/InfoTertiary";
import Address from "../components/Home/Address";
import Updates from "../components/Home/Updates";

const HomePage = () => {
  return (
    <>
      <PrimarySection
        className={styles.primarySection}
        backgroundImage={homeBackgroundImg}
      >
        <img
          className={styles.headingImg}
          src={headingImg}
          alt="Improve Enhance"
        />
      </PrimarySection>
      <CtaLink />
      <Details />
      <Facilities />
      <Events />
      <Info />
      <InfoSecondary />
      <InfoTertiary />
      <Address />
      <Updates />
    </>
  );
};

export default HomePage;
